import { IResult, IRouteParam } from "../types";

const solveSubmitHighlight = async (props: IRouteParam): Promise<IResult> => {
  const { currfileStepData, prevfileStepData } = props;

  return {
    RevisionInformation: {
      RevisionCategory: true,
      RequestDate: true,
      RequestFrom: true,
      RevisionDescription: true,
      RevisionAttachment: currfileStepData.revisionFormInfo.attachmentFiles.length > 0,
    },
    ProcedureFiles: {
      ProcedureSavedIn: prevfileStepData.procedureSaveInCategoryID !== currfileStepData.procedureSaveInCategoryID,
      SavedInStatus: false,
      ClientServerPath: prevfileStepData.clientServerPath !== currfileStepData.clientServerPath,
      ServerPathStatus: false,
      LevelCChange: false,
      // not 'No Change' tag files
      FileNameList: currfileStepData.procedureFiles.filter((i) => i.fileTagID).map((i) => `file-${i.fileID}`),
    },
  };
};

export default solveSubmitHighlight;
